/**
 * Pobiera listę kursów
 */

import { GET_COURSES, SHOW_SPINNER, HIDE_SPINNER, COURSES_LOADED } from '../types';
import api from '../../api';
import sessionErrHandler from './sessionErrHandler';

export const getCourses = () => async dispatch => {
  dispatch({ type: SHOW_SPINNER, payload: 'Pobieranie listy kursów...' });

  const options = {
    method: 'get',
    url: '/course',
    withCredentials: true
  }

  let response = {};
  try {
    response = await api(options);
  } catch (e) {
    sessionErrHandler(e, 'Błąd Pobierania kursów', dispatch);
  }

  dispatch({ type: HIDE_SPINNER });

  if (response.status === 200) {
    dispatch({ type: GET_COURSES, courses: response.data });
    dispatch({ type: COURSES_LOADED, payload: true });
  }
}
